var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import columns from './columns';
export default __assign(__assign({}, columns), { averageDailySales: {
        label: 'Média de venda diária',
        field: 'averageDailySales',
        type: 'general',
        align: 'left',
        customWidth: 200,
        fixed: false,
        render: true,
        disableOrder: true,
    }, averageMonthlySales: {
        label: 'Média de venda mensal',
        field: 'averageMonthlySales',
        type: 'general',
        align: 'left',
        customWidth: 200,
        fixed: false,
        render: true,
        disableOrder: true,
    }, averageAnnualSales: {
        label: 'Média de venda anual',
        field: 'averageAnnualSales',
        align: 'left',
        customWidth: 200,
        fixed: false,
        render: true,
        disableOrder: true,
    }, currentSaleMonth: {
        label: 'Mês de venda atual',
        field: 'currentSaleMonth',
        type: 'general',
        align: 'left',
        customWidth: 200,
        fixed: false,
        render: true,
        disableOrder: true,
    }, gama: {
        label: 'Gama',
        field: 'gama',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
        disableOrder: true,
    }, mdh: {
        label: 'MDH',
        field: 'mdh',
        type: 'general',
        align: 'left',
        customWidth: 100,
        fixed: false,
        render: true,
        disableOrder: true,
    }, top: {
        label: 'TOP 2500',
        field: 'top',
        type: 'general',
        align: 'left',
        customWidth: 100,
        fixed: false,
        render: true,
        disableOrder: true,
    }, topping: {
        label: 'Topagem',
        field: 'topping',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
        disableOrder: true,
    }, beepedBy: {
        label: 'price.audit.beepedBy',
        field: 'beepedBy',
        type: 'general',
        align: 'left',
        customWidth: 350,
        fixed: false,
        render: true,
        disableOrder: true,
    } });
